import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import Box from '@mui/material/Box';
import Logo from './Logo';
import ItemsList from './ItemsList';
import { setIsNavigationDropdownOpened } from '../../../redux/features/general/navigation';
import { useNavigate } from 'react-router-dom';

type Props = {
  children?: React.ReactNode;
  disableShadow?: boolean; 
};

const NavBar: React.FC<Props> = ({ children, disableShadow }) => {

  const dispatch = useAppDispatch(); 

  const colors = useAppSelector(state => state.theme.colors);

  const groupInfo = useAppSelector(state => state.meta.groupInfo); 

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100vw',
        height: '5vh',
        position: 'absolute',
        backgroundColor: colors?.navBar,
        boxShadow: disableShadow ? '' : '0 4px 6px rgba(0, 0, 0, 0.2)',
        zIndex: 10000000,
        padding: '0 1vw',
      }}
    >

      <Box onClick={() => window.location.href = '/dashboard'} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <Logo size={20} />
      </Box>

      {groupInfo?.name && 
      <Box
          sx={{ 
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-evenly', 
              textAlign: 'center',
              fontSize: 12, 
              color: 'rgb(150, 150, 150)',
              marginRight: 2, 
              left: 0, 
              width: '100%', 
              position: 'absolute',
          }}
      >{groupInfo?.name}
      </Box>}

      <ItemsList>
        {children}
      </ItemsList>
    </Box>
  );
};

export default NavBar;